import React from 'react'
import '../../../../assets/scss/components/createNewUser.scss'
import UserForm from './UserForm';
const CreateNewUser = () => {

    return (
        <div className=" bg-white shadow rounded border border-light create-new-user">
            <h4 className="text-center text-primary font-weight-bold display-5">Create New User</h4>
            <UserForm />
        </div >
    )
}

export default CreateNewUser

